// extracted by mini-css-extract-plugin
export default {"popUpContainer":"styles_popUpContainer__bn2vG"};